import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface DarkModeContextType {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
}

const DarkModeContext = createContext<DarkModeContextType | undefined>(undefined);

export const DarkModeProvider = ({ children }: { children: ReactNode }) => {
  // Inicializar lendo o estado do DOM (já configurado pelo script anti-flicker)
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
    try {
      // Ler APENAS do localStorage - NÃO do DOM
      // O script inline já aplicou a classe correta, não devemos remover
      const saved = localStorage.getItem('darkMode');
      return saved === 'true';
    } catch (e) {
      return false;
    }
  });

  // Aplicar dark mode ao DOM APENAS quando o usuário alternar manualmente
  useEffect(() => {
    const root = document.documentElement;

    // Aplicar classe
    if (isDarkMode) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }

    // Salvar preferência
    try {
      localStorage.setItem('darkMode', String(isDarkMode));
    } catch (e) {
      console.error('❌ [DarkMode] Erro ao salvar:', e);
    }
  }, [isDarkMode]);

  // Função para alternar o modo
  const toggleDarkMode = () => {
    setIsDarkMode(prev => !prev);
  };

  return (
    <DarkModeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
};

export const useDarkMode = () => {
  const context = useContext(DarkModeContext);
  if (context === undefined) {
    throw new Error('useDarkMode deve ser usado dentro de DarkModeProvider');
  }
  return context;
};
